import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const BCIndustryActivity = React.lazy(() =>
    import('../BCIndustryActivity')
);
const bCIndustryActivityRoutesRegistry = [
    {
        path: PAGE_URL.B_C_INDUSTRY_ACTIVITY_PAGE,
        element: <BCIndustryActivity />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default bCIndustryActivityRoutesRegistry;
